import {
  TASK_INSTANCE_UNASSIGNED_STATE,
  TASK_INSTANCE_AVAILABLE_STATE,
  TASK_INSTANCE_PENDING_STATE,
  TASK_INSTANCE_COMPLETED_STATE,
  TASK_INSTANCES_GROUP_BY_LOCATION,
  TASK_INSTANCES_GROUP_BY_POSITION,
} from '../../constants';

const SECTION_TO_TAB_NAME_MAP = {
  [TASK_INSTANCE_UNASSIGNED_STATE]: 'Unassigned tasks',
  [TASK_INSTANCE_AVAILABLE_STATE]: 'Available tasks',
  [TASK_INSTANCE_PENDING_STATE]: 'Assigned tasks',
  [TASK_INSTANCE_COMPLETED_STATE]: 'Completed tasks',
  all: 'All tasks',
};

const PERSONA_BASED_GROUPINGS = [
  TASK_INSTANCES_GROUP_BY_LOCATION,
  TASK_INSTANCES_GROUP_BY_POSITION,
];

export default function buildSections(groupedInstances, groupMethod, personasDict) {
  const sections = Object.keys(groupedInstances)
    .map((sectionKey) => {
      if (!groupedInstances[sectionKey]?.length) {
        return null;
      }
      return {
        key: sectionKey,
        name: getSectionName(sectionKey, groupMethod, personasDict),
        data: [...groupedInstances[sectionKey]],
        isOpened: true,
        isUnassigned: sectionKey === TASK_INSTANCE_UNASSIGNED_STATE,
        isAvailable: sectionKey === TASK_INSTANCE_AVAILABLE_STATE,
      };
    })
    .filter(Boolean);
  sections.sort(sortSections);
  return sections;
}

function getSectionName(sectionKey, groupMethod, personasDict) {
  if (SECTION_TO_TAB_NAME_MAP[sectionKey]) {
    return SECTION_TO_TAB_NAME_MAP[sectionKey];
  }

  if (PERSONA_BASED_GROUPINGS.includes(groupMethod)) {
    return personasDict[sectionKey]?.name;
  }

  return 'Other';
}

function sortSections(sectionA, sectionB) {
  if (sectionA.isUnassigned) {
    return -1;
  }

  if (sectionB.isUnassigned) {
    return 1;
  }

  if (sectionA.isAvailable) {
    return -1;
  }

  if (sectionB.isAvailable) {
    return 1;
  }

  return sectionA.name.localeCompare(sectionB.name);
}
